import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import './HeroBlock.scss';
import { withContent } from '../../../hoc/withContext';
import { IContent, IProduct } from '../../../types';
import { cleanSpaces, getProductURL, sendEvent } from '../../../utils';

// @ts-ignore
import Fade from 'react-reveal/Fade';

import TrailerModal from '../../Elements/Modals/TrailerModal/TrailerModal';
import AgeGateModal from '../../Elements/Modals/AgeGateModal/AgeGateModal';
import Image from '../../UI/Image/Image';
import BackgroundImage from '../../UI/Image/BackgroundImageElement';
import Modal from '../../UI/Modal/Modal';
import PriceContainer from '../../UI/Price/PriceContainer';
import Video from '../../UI/Video';
import Loader from '../../Elements/Loader/Loader';
import videoTrailers from "../../../utils/trailer";

interface IHeroBlockProps {
  context?: IContent;
  products?: IProduct[];
}

const Hero = (props: IHeroBlockProps) => {
  const [showTrailer, setShowTrailer] = useState(false);
  const [showAgeGate, setShowAgeGate] = useState(false);

  const { context, products } = props;
  const { age_gate, hero, config, global, lang } = context;
  const { bg, trailer_image, video, is_active } = hero;

  const IS_CHINA = lang === "zh_CN";

  const handleTrailerGuard = () => {
    sendEvent(hero.cta.tracking);

    // @ts-ignore
    if (IS_CHINA || (window.ConsentResources && window.ConsentResources.videoConsent)) {
      if (age_gate.is_active && !localStorage.getItem('hasValidatedAgeGate')) {
        setShowAgeGate(true);
      } else {
        setShowTrailer(true);
      }
    }
  };

  const productFound = products ? products.filter((product: IProduct) => product.id === cleanSpaces(hero.product.product_id)) : [];

  return is_active && (
    <div className="block-hero">
      {videoTrailers.map(trailer => <input type="hidden" key={trailer.id} data-video-id={trailer.id} data-video-src={trailer.path}/>)}
      {bg.video && (
        <Video nativeProps={{ className: 'video', autoPlay: true, muted: true }} muted={true}>
          <source src={require(`../../../assets/${bg.video}.mp4`)} type="video/mp4" />
          <source src={require(`../../../assets/${bg.video}.webm`)} type="video/webm" />
        </Video>
      )}
      <BackgroundImage
        classNames={["bg-desktop"]}
        imageName={bg.image.desktop}
      >
        <Fade delay={100} duration={600}>
          <h1 className="block-title" dangerouslySetInnerHTML={{ __html: hero.title }} />
        </Fade>
        <div className="content">
          <div className="items">
            <Fade delay={300} duration={600}>
              <div className="description">{hero.description}</div>
            </Fade>
            {video && (
              <Fade delay={400} duration={600}>
                <div className="trailer">
                  <div className="trailer-mobile">
                    <Image
                      imageName={bg.image.mobile}
                      altText=""
                    />
                  </div>
                  <div className="trailer-img">
                    <Image
                      imageName={trailer_image}
                      altText=""
                    />
                  </div>
                  <button className={`trailer-button${!IS_CHINA ? " youtube-content" : ""}`} onClick={() => handleTrailerGuard()}>
                    <Image
                      imageName="play.svg"
                      altText=""
                    />
                  </button>
                </div>
              </Fade>
            )}
            {
              !products.length
                ? (<Loader />)
                : (products.length && productFound.length === 1) ? (
                  <>
                    <div className="edition">
                      {productFound[0].Edition}
                    </div>
                    <div className="price">
                      <div className="inner">
                        <PriceContainer product={productFound[0]} />
                      </div>
                    </div>
                    <div className="button">
                      <a
                        className="preorder"
                        href={getProductURL(cleanSpaces(hero.product.product_id), config.country_code)}
                        onClick={() => sendEvent(hero.cta.tracking)}
                        data-alt-text={global.preorder}
                      >
                        <span>{global.preorder}</span>
                      </a>
                    </div>
                  </>
              )
              : null
            }
          </div>
        </div>
      </BackgroundImage>
      {(video || IS_CHINA) && (
        <Fragment>
          <Modal
            open={showTrailer}
            close={() => setShowTrailer(false)}
          >
            <TrailerModal
              video={video}
              type={IS_CHINA ? "video" : "youtube"}
            />
          </Modal>
          <Modal
            open={showAgeGate}
            close={() => setShowAgeGate(false)}
          >
            <AgeGateModal
              close={() => setShowAgeGate(false)}
              next={() => setShowTrailer(true)}
            />
          </Modal>
        </Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products.data
});

export default connect(mapStateToProps)(withContent(Hero));
